import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";

import { BranchCustomAddressForm } from "@features/addresses";
import { EditingDialog } from "@features/editor/Dialog";
import { useEditor } from "@features/editor/Editor";
import { Address } from "@models/Address";

const NewBranchAddressButton = ({
  handleCreateOrders,
}: {
  handleCreateOrders: (addressIds: string[]) => void;
}) => {
  const editor = useEditor<Address>();
  const { start, complete } = editor;
  const onSuccess = (address: Address) => {
    handleCreateOrders([address.id]);
    complete();
  };
  return (
    <>
      <Button color="primary" endIcon={<Add />} onClick={() => start()}>
        New Address
      </Button>
      <EditingDialog subjectLabel="Address" {...editor}>
        <BranchCustomAddressForm onSuccess={onSuccess} />
      </EditingDialog>
    </>
  );
};

export default NewBranchAddressButton;
